// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

type QuerySuggestionsType = {
    suggestions: any[] | undefined;
};

type AutoCompleteSearchSuggestions = Readonly<{
    querySuggestions: QuerySuggestionsType;
}>;

const initialXAutoCompleteSearchSuggestions: AutoCompleteSearchSuggestions = {
    querySuggestions: {
        suggestions: undefined,
    },
};

const reducer = {
    "xAutoCompleteSearchSuggestions/CompleteLoad": (
        draft: Draft<AutoCompleteSearchSuggestions>,
        action: { xAutoCompleteSearchSuggestions: AutoCompleteSearchSuggestions },
    ) => {
        draft.querySuggestions = action.xAutoCompleteSearchSuggestions.querySuggestions;
    },
};

const xAutoCompleteSearchSuggestions = createTypedReducerWithImmer(initialXAutoCompleteSearchSuggestions, reducer);

(reducers as any).xAutoCompleteSearchSuggestions = xAutoCompleteSearchSuggestions;

export type xAutoCompleteSearchSuggestions = {
    xAutoCompleteSearchSuggestions: AutoCompleteSearchSuggestions;
};

type xAutoCompleteSearchSuggestionsReducers = {
    querySuggestions: typeof xAutoCompleteSearchSuggestions;
};

export type xAutoCompleteSearchSuggestionsActions =
    | Parameters<xAutoCompleteSearchSuggestionsReducers[keyof xAutoCompleteSearchSuggestionsReducers]>[1]
    | AnyAction;
